import { render, staticRenderFns } from "./bindWxUser.vue?vue&type=template&id=12c9cce9&scoped=true"
import script from "./bindWxUser.vue?vue&type=script&lang=js"
export * from "./bindWxUser.vue?vue&type=script&lang=js"
import style0 from "./bindWxUser.vue?vue&type=style&index=0&id=12c9cce9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9cce9",
  null
  
)

export default component.exports